import { observable, action, autorun, computed } from 'mobx';
import { notification } from 'antd';
import { persist } from 'mobx-persist';
import { request } from '~/utils/';

class State {
  @persist
  @observable
  accessToken = ''; //'EAACwl5C3VMQBABCZAZCYf3zPuuMJWRbxH5K7QkYRxY59ZBRev5JyaWei38gqaPhd83niyZBweSnAAgDO1UljNOIK7rIM7lZBtAGRflZBJDtu4GzZAZBkEzJWNgNhJ7E2aZC49IC0sRII2borBIwsyxpPUQCpQUKudZA8atJWSBVmq5GgZDZD';

  @persist
  @observable
  userId = '';

  @persist
  @observable
  userName = '';

  @observable _groups = [];

  @observable _pages = [];

  @observable _friends = [];

  @observable auth_loading = false;

  @persist('map')
  @observable
  streams = new Map();

  @persist('map')
  @observable
  details = new Map();

  constructor(root) {
    this.root = root;
    autorun(() => {
      console.log('#token', this.accessToken);
      if (this.accessToken) {
        this.loadProfile();
      }
    });
  }

  @computed
  get friends() {
    const _friends = this._friends;
    return _friends.length > 0 ? _friends.peek() : [];
  }

  @computed
  get groups() {
    const _groups = this._groups;
    return _groups.length > 0 ? _groups.peek() : [];
  }

  @computed
  get pages() {
    const _pages = this._pages;
    return _pages.length > 0 ? _pages.peek() : [];
  }

  @action
  auth = async (code, callback) => {
    if (this.accessToken) return;
    this.auth_loading = true;
    try {
      const { data: shortTokenData } = await request.get(
        `https://openapi.insta360.com/tools/v1/facebook/getOauthToken?client_id=194165014484164&code=${code}`
      );
      const shortAccessToken = shortTokenData.data.access_token;
      const { data: longTokenData } = await request.get(
        `https://openapi.insta360.com/tools/v1/facebook/getOauthLongToken?client_id=194165014484164&short_live_token=${shortAccessToken}`
      );
      this.accessToken = longTokenData.data.access_token;
    } catch (error) {
      notification.open({
        message: 'Auth',
        description: JSON.stringify(error),
      });
    } finally {
      this.auth_loading = false;
      typeof callback === 'function' && callback();
    }
  };

  @action
  loadProfile = async () => {
    const accessToken = this.accessToken;
    try {
      const { data: profile } = await request.get(
        `https://graph.facebook.com/v2.11/me?access_token=${accessToken}`
      );
      const { id: userId, name: userName } = profile;
      this.userId = userId;
      this.userName = userName;
    } catch (error) {
      notification.open({
        message: 'Load',
        description: JSON.stringify(error),
      });
    }
  };

  @action
  load = async () => {
    const accessToken = this.accessToken;
    const userId = this.userId;
    try {
      const { data: pages } = await request.get(
        `https://graph.facebook.com/v2.11/${userId}/accounts?access_token=${accessToken}`
      );

      const { data: groups } = await request.get(
        `https://graph.facebook.com/v2.11/${userId}/groups?access_token=${accessToken}`
      );

      const { data: friends } = await request.get(
        `https://graph.facebook.com/v2.11/${userId}/friendlists?fields=name&access_token=${accessToken}`
      );

      this._pages = pages.data;
      this._groups = groups.data;
      this._friends = friends.data;
    } catch (error) {
      notification.open({
        message: 'Load',
        description: JSON.stringify(error),
      });
    }
  };

  @action
  create = async (values, opts) => {
    const { share, title, description } = values;
    const params = {
      title,
      description,
      is_spherical: true,
      encoding_settings: 'equirect_uhd_aac_30fps',
      _share: share,
    };

    if (share === 'timeline') {
      const perms = values.permission.split('#');
      const privacy = {};
      privacy.value = perms[0];
      if (perms.length > 1) {
        privacy.allow = perms[1];
      }
      params.privacy = privacy;
      params._id = this.userId;
      params._accessToken = this.accessToken;
    }

    if (share === 'page') {
      const _page = this.pages.find(page => {
        return page.id === values.page;
      });
      params.privacy = { value: 'EVERYONE' };
      params._id = values.page;
      params._accessToken = _page.access_token;
    }

    if (share === 'group') {
      params.privacy = { value: 'EVERYONE' };
      params._id = values.group;
      params._accessToken = this.accessToken;
    }

    try {
      console.log(params);
      const { _id: id, _accessToken: accessToken } = params;
      const { data } = await request.post(
        `https://graph.facebook.com/v2.11/${id}/live_videos?access_token=${accessToken}`,
        params
      );
      console.log(data);
      const { id: streamId } = data;
      this.details.set(streamId, Object.assign({}, params, { status: '0' }));
      this.streams.set(streamId, data);

      opts.success && opts.success();
    } catch (error) {
      notification.open({
        message: 'Creation',
        description: JSON.stringify(error),
      });

      opts.fail && opts.fail();
    }
  };

  @action
  update = async (streamId, status) => {
    try {
      const detail = this.details.get(streamId);
      const { _id: id, _accessToken: accessToken } = detail;
      const { data } = await request.post(
        `https://graph.facebook.com/v2.11/${id}/live_videos?access_token=${accessToken}`,
        status
      );
      console.log(data);

      this.details.set(
        streamId,
        Object.assign({}, detail, {
          status: '3',
        })
      );
    } catch (error) {
      notification.open({
        message: 'Update',
        description: JSON.stringify(error),
      });
    }
  };

  @action
  clearToken = async () => {
    this.accessToken = '';
    this.userId = '';
    this.userName = '';
    this.streams.clear();
    this.details.clear();
  };

  @action
  remove = id => {
    this.streams.delete(id);
    this.details.delete(id);
  };
}

export default State;



// WEBPACK FOOTER //
// ./src/store/fb.js